// Linear interpolation.
export var lerp = function (step, steps, min, max) {
    return (step / steps) * (max - min) + min;
};
